import { render, staticRenderFns } from "./loyalty-cards.vue?vue&type=template&id=43a90e1a&"
import script from "./loyalty-cards.vue?vue&type=script&lang=js&"
export * from "./loyalty-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports